import { useContext } from 'react';
import { VoIPContext } from '../context/VoIPContext';

export const useVoIP = () => {
  const context = useContext(VoIPContext);

  if (!context) {
    throw new Error('useVoIP must be used within VoIPProvider');
  }

  return context;
};
